import React from 'react';
import ResponsiveImage from '../ResponsiveImage';

interface INotificationToastProps {
  image: string;
  message: string;
}

const ToastWithImage: React.FC<INotificationToastProps> = ({
  image,
  message,
}) => (
  <>
    <div className="toast-with-image tw-flex tw-p-2 container">
      <ResponsiveImage src={image} width={30} height={30} />
      <p className="tw-p-2">{message}</p>
    </div>
  </>
);

export default ToastWithImage;
